/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type PlaceholderStatus = typeof PlaceholderStatus[keyof typeof PlaceholderStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlaceholderStatus = {
  Active: 'Active',
  Archived: 'Archived',
} as const;
